// Constants

export const CLASS_TYPES = ['Bhangra', 'Gidha', 'Dhol', 'Bollywood', 'Competition', 'Choreo', 'Other'];

export const AGE_GROUPS = ['Littles', 'Kids', 'Teens', 'Young Adults', 'Adults'];

export const RUMAAL_RANKS = ['White', 'Yellow', 'Green', 'Blue', 'Red', 'Black'];

export const STUDENT_STATUSES = ['Active', 'Trial', 'Paused', 'Cash'];

export const TRIAL_STAGES = ['In Progress', 'Attending', 'Attended'];

export const DURATION_OPTIONS = [
  { label: '45 min', value: 45 },
  { label: '60 min', value: 60 },
  { label: '75 min', value: 75 },
  { label: '90 min', value: 90 },
  { label: '120 min', value: 120 },
];

export const BHANGRA_INSTRUCTORS = [
  'Pratap',
  'ASG',
  'Gugu',
  'Gurveen',
  'Harneet',
  'Vicky',
  'Gurmehak',
  'Kim',
  'Sehaj',
];

export const GIDHA_INSTRUCTORS = [
  'Gugu',
  'Harneet',
  'Gurveen',
];

export const DHOL_INSTRUCTORS = [
  'Nikki',
];

export const BOLLYWOOD_INSTRUCTORS = [
  'Roshni',
  'Swati',
  'Kim',
  'Gugu',
];

export const LOCATIONS = [
  'Studio A',
  'Studio B',
  'Compound',
];

